.question {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.scoreChip {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  font-size: var(--tuna-typography-caption-fontSize);
  background: var(--tuna-surface-elevated);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
}

.prompt {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.actionRow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.cardGrid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--tuna-spacing-2);
}

@media (max-width: 899.95px) {
  .cardGrid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 599.95px) {
  .cardGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}
